import { render, staticRenderFns } from "./motd.vue?vue&type=template&id=e45117bc&"
import script from "./motd.vue?vue&type=script&lang=js&"
export * from "./motd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports